<div class="cba-main-container">
    <div class="cba-icon-container">
        <div class="cba-icon-text-container">AI</div>
    </div>
    <div class="cba-container">
        <div *ngIf="message" class="cba-text-container">
            <!-- Display raw HTML using innerHTML binding -->
            <!-- prose helps it prevent from default tailwind plaining of css -->
            <markdown class="prose dark:prose-dark" [data]="message"></markdown>
        </div>
        <div *ngIf="files && files.length > 0" class="mt-3">
            <div class="cba-file-text">Files:</div>
            <div class="cba-file-list">
                <button *ngFor="let file of files" (click)="downloadCertificate(file.url)"
                    class="rounded-full border border-[#289DD2] text-gray-300 px-6 py-2 hover:border-2 w-fit hover:text-white self-center text-sm sticky bottom-0 mr-3 mt-1">
                    Download {{ file.name }}
                </button>
            </div>
        </div>

    </div>
